import React, {useEffect, useState} from 'react';

import {Typography, useTheme} from '@mui/material';
import {
  Stack,
} from '@zoom/react-ui';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

import {NewFeatBadge} from './Style';

import {ReactComponent as ThinCancel} from 'assets/svg/thin-cancel-x.svg';
import {ZmPrimaryLink} from 'Components/ZmLink/ZmLink';
import {ZmPopover} from 'Components/ZmPopover/ZmPopover';
import {inZoomClient} from 'Utils/integration';
import {openUrlInBrowser, WEB_SCHEDULER_URL} from 'Utils/ZoomClientUtils';

export const CustomLinkPopup = ({className, ...props}) => {
  const [isPopperOpen, setIsPopperOpen] = useState(false);

  const theme = useTheme();
  const handleClose = () => {
    setIsPopperOpen(false);
    localStorage.setItem('customLinkShown', true);
  };

  useEffect(() => {
    const customLinkShown = localStorage.getItem('customLinkShown');
    if (!customLinkShown) {
      setIsPopperOpen(true);
      const timer = setTimeout(() => {
        localStorage.setItem('customLinkShown', true);
      }, 10000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, []);

  return <ZmPopover
    {...props}
    sx={{
      // Want the new feature popover to render below the ApptForm modal
      zIndex: theme.zIndex.modal - 1,
      ...props?.sx,
    }}
    title={<CustomLinkPopupContent handleClose={handleClose}/>}
    open={isPopperOpen}
    placement="bottom-start"
    arrow
  />;
};

/**
 *
 * @param {Object} props
 * @return {ReactElement}
 */
function CustomLinkPopupContent(props) {
  const {handleClose} = props;
  const {t} = useTranslation();
  const navigate = useNavigate();

  return (<>
    <Stack style={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    }}>
      <Typography variant="h4" sx={{
        margin: 0,
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: 600,
        overflowWrap: 'anywhere',
        width: '208px',
      }}>
        <NewFeatBadge>New</NewFeatBadge>
        {t('landing.customLink')}
      </Typography>
      <ThinCancel
        role="button"
        aria-label="cancelBtn"
        cursor={'pointer'}
        onClick={handleClose}
      />
    </Stack>
    <Typography variant="body2" sx={{
      margin: 0,
      marginTop: '4px',
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: 450,
      overflowWrap: 'anywhere',
      width: '208px',
    }}>
      {t('landing.customLinkIntro')}
    </Typography>
    <ZmPrimaryLink
      underline="hover"
      href=""
      onClick={(e) => {
        e.preventDefault();
        handleClose();
        if (inZoomClient) {
          openUrlInBrowser(`${WEB_SCHEDULER_URL}?action=settings-profile`);
        } else {
          navigate('/me/settings/profile');
        }
      }}
    >
      <Typography
        sx={{fontSize: '.875rem', fontWeight: 500}}
      >
        {t('landing.setUp')}
      </Typography>
    </ZmPrimaryLink>
  </>);
}
